import Home from "./pages/home/Home";
import { MantineProvider } from "@mantine/core";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import SpecificBlog from "./components/BlogDetailPage";
import AllServices from "./components/ServicesPage";
import SEO from "./components/SEO";
import "@mantine/carousel/styles.css";

function App() {
  return (
    <div className="overflow-x-hidden w-full">
      <MantineProvider>
        <BrowserRouter>
          <SEO />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/blog/:id" element={<SpecificBlog />} />
            <Route path="/service" element={<AllServices />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </MantineProvider>
    </div>
  );
}

export default App;
